import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useGetSettlementsById(settlementId) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const { send, isConnected, connect, registerHandler } = useWebSocketContext();

  const mountedRef = useRef(true);
  const retryTimeoutRef = useRef(null);

  const fetchSettlement = useCallback(
    async (attempt = 0) => {
      if (!mountedRef.current || !settlementId) return;

      setIsLoading(true);
      setError("");

      try {
        if (!isConnected) {
          await connect();
        }

        const response = await send("cms_get_stations_settlement_by_id", {
          settlement_id: settlementId,
        });
        console.log("Fetched settlement by ID:", response);
        if (
          !response ||
          response.type !== "cms_get_stations_settlement_by_id_response"
        ) {
          throw new Error("Invalid response");
        }

        setData(response.data || null);
        setMessage(response.message || "Settlement fetched successfully");
      } catch (err) {
        console.warn("Settlement fetch failed:", err.message);

        // if (mountedRef.current) {
        //   const delay = Math.min(1000 * Math.pow(2, attempt), 30000);
        //   retryTimeoutRef.current = setTimeout(() => {
        //     fetchSettlement(attempt + 1);
        //   }, delay);
        // }
      } finally {
        if (mountedRef.current) setIsLoading(false);
      }
    },
    [settlementId, isConnected, connect, send]
  );

  useEffect(() => {
    mountedRef.current = true;

    if (settlementId) {
      fetchSettlement();
    }

    const unregister = registerHandler(
      `settlement_update_${settlementId}`,
      (msg) => {
        if (msg?.data) {
          setData(msg.data);
        }
      }
    );

    return () => {
      mountedRef.current = false;
      if (retryTimeoutRef.current) clearTimeout(retryTimeoutRef.current);
      unregister();
    };
  }, [fetchSettlement, registerHandler, settlementId]);

  return {
    data,
    isLoading,
    error,
    message,
    refetch: () => fetchSettlement(0),
  };
}
